<fz-card-details>
  <!-- Name -->
  <!--
    - If tournament is life experience show always the name of the tournament
    - If tournament is not life experience and to play now is enabled show the
      name of the tournament and the event code.
  -->
  <fz-card-item>
    <fz-card-item-title>Tournament</fz-card-item-title>
    <fz-card-item-description>
      @if (tournament().lifeExperience) {
        {{ tournament().name }}
      } @else {
        @if (includeToPlayNow()) {
          @if (tournament().toPlayNow) {
            <small>{{ tournament().name }}</small>
            {{ schedule()!.toPlayNow?.eventCode }}
          } @else {
            <div class="loader"></div>
          }
        } @else {
          {{ tournament().name }}
        }
      }
    </fz-card-item-description>
  </fz-card-item>

  <!-- If is cash show seats -->
  @if (!tournament().lifeExperience) {
    <fz-card-item label="Seats">
      <fz-card-item-title>Seats</fz-card-item-title>
      <fz-card-item-description> {{ seats() }} </fz-card-item-description>
    </fz-card-item>
  }

  <!-- Add divider -->
  <mat-divider></mat-divider>

  <!-- If life experience show prize -->
  @if (tournament().lifeExperience) {
    <fz-card-expansion-item>
      <fz-card-item-title>Prize</fz-card-item-title>
      <fz-card-item-description>
        <img
          [src]="tournament().prizeDetails?.prizeImageCard! | prizeImage"
          [alt]="tournament().prizeDetails?.prizeName ?? 'Tournament prize'"
          [title]="tournament().prizeDetails?.prizeName ?? 'Tournament prize'"
          [matTooltip]="
            tournament().prizeDetails?.prizeDetails ?? 'Tournament prize'
          "
          height="24"
        />
        <span class="mat-body-small">{{
          tournament().prizeDetails?.prizeName
        }}</span>
      </fz-card-item-description>
      <fz-card-item-body>
        <div class="display--flex flex-direction--column align-items--center">
          <img
            [src]="tournament().prizeDetails?.prizeImageCard! | prizeImage"
            [alt]="tournament().prizeDetails?.prizeName ?? 'Tournament prize'"
            [title]="tournament().prizeDetails?.prizeName ?? 'Tournament prize'"
            height="128"
          />
        </div>
      </fz-card-item-body>
    </fz-card-expansion-item>
  } @else {
    <fz-card-item>
      <fz-card-item-title>1st Prize</fz-card-item-title>
      <fz-card-item-description>
        <img
          src="/shared/icons/coin-bag.svg"
          width="24"
          height="24"
          alt="First prize"
        />
        @if (firstPlacePrize()) {
          <fz-currency [value]="firstPlacePrize()!"></fz-currency>
        }
      </fz-card-item-description>
    </fz-card-item>
  }

  <!-- Entry Fee -->
  <fz-card-item>
    <fz-card-item-title>Entry Fee</fz-card-item-title>
    <fz-card-item-description>
      <fz-currency
        [value]="tournament().eventSchedules[0].entryAmount"
      ></fz-currency>
    </fz-card-item-description>
  </fz-card-item>
  <!-- <mat-divider></mat-divider> -->

  <!-- Show To Play Now if it enabled -->
  @if (includeToPlayNow()) {
    <fz-card-expansion-item
      (opened)="togglePlayNowExpended(true)"
      (closed)="togglePlayNowExpended(false)"
    >
      <fz-card-item-title
        info="Tournament instance you'll join when you click the Play button."
      >
        To Play Now
      </fz-card-item-title>
      <fz-card-item-description>
        @if (isOpened()) {
          <span class="mat-body-small font-color--tertiary">Hide</span>
        } @else {
          @if (tournament().toPlayNow) {
            @if (tournament().lifeExperience) {
              @if (tournament().toPlayNow?.participants?.length === 0) {
                Just started. Be the first!
              } @else {
                {{ tournament().toPlayNow?.participants?.length }} users have
                played
              }
            } @else {
              @if (
                tournament().toPlayNow?.availableSeats ==
                tournament().toPlayNow?.seats
              ) {
                {{ tournament().toPlayNow?.availableSeats }} available seat{{
                  tournament().toPlayNow!.availableSeats > 1 ? 's' : ''
                }}
                ({{ tournament().toPlayNow?.participants?.length }}/{{
                  tournament().toPlayNow?.seats
                }})
              } @else {
                All seats available
              }
            }
          } @else {
            <div class="loader"></div>
          }
        }
      </fz-card-item-description>
      <fz-card-item-body>
        <div class="cash-card__body">
          <div class="mat-body-small cash-card__body__column">
            <span>
              @if (tournament().toPlayNow) {
                @if (tournament().lifeExperience) {
                  @if (tournament().toPlayNow?.participants?.length === 0) {
                    Just started. Be the first!
                  } @else {
                    {{ tournament().toPlayNow?.participants?.length }} users
                    have played
                  }
                } @else {
                  @if (
                    tournament().toPlayNow?.availableSeats ==
                    tournament().toPlayNow?.seats
                  ) {
                    {{ tournament().toPlayNow?.availableSeats }} available
                    seat{{
                      tournament().toPlayNow!.availableSeats > 1 ? 's' : ''
                    }}
                    ({{ tournament().toPlayNow?.participants?.length }}/{{
                      tournament().toPlayNow?.seats
                    }})
                  } @else {
                    All seats available
                  }
                }
              } @else {
                <div class="loader"></div>
              }
            </span>
            <span>
              1st place:
              <b class="font-color--primary">
                @if (tournament()!.toPlayNow?.participants?.length) {
                  {{ tournament()!.toPlayNow!.participants[0].player }}
                } @else {
                  Be the first.
                }
              </b>
            </span>
          </div>
          <div class="mat-body-small cash-card__body__column">
            <span>
              @if (tournament().toPlayNow?.firstPlayedAt) {
                Started on
                {{
                  tournament().toPlayNow?.firstPlayedAt
                    | fzDateFormat: 'medium'
                    | async
                }}
              } @else {
                Start this game by playing in it.
              }
            </span>
            <span>
              @if (tournament().toPlayNow?.lastPlayedAt) {
                Last played on
                {{
                  tournament().toPlayNow?.lastPlayedAt
                    | fzDateFormat: 'medium'
                    | async
                }}
              }
            </span>
          </div>
        </div>
      </fz-card-item-body>
    </fz-card-expansion-item>
  }

  <!-- Actions -->
  <fz-card-actions>
    <fz-play-button
      class="cash-card__play-button"
      [tournament]="tournament()"
      [eventSchedule]="tournament().eventSchedules[0]"
    >
    </fz-play-button>
    <span class="cash-card__expanded"></span>
    <button mat-icon-button (click)="shareTournament()">
      <mat-icon class="font-color--tertiary">share</mat-icon>
    </button>
    <a mat-icon-button [href]="tournament() | fzTournamentUrl">
      <mat-icon class="font-color--tertiary">visibility</mat-icon>
    </a>
  </fz-card-actions>
</fz-card-details>
